var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.696 11.124c-.386.47-1.005.84-1.624.787-.077-.635.226-1.309.58-1.725.387-.482 1.064-.826 1.612-.852.064.66-.187 1.308-.568 1.79zm.561.912c-.545-.032-1.043.168-1.444.33-.259.104-.478.192-.645.192-.186 0-.414-.092-.67-.197-.336-.136-.72-.293-1.121-.285-.922.013-1.78.548-2.25 1.401-.967 1.705-.252 4.23.683 5.617.458.687 1.006 1.44 1.728 1.414.317-.012.546-.111.782-.214.272-.119.555-.242.997-.242.426 0 .696.12.956.235.247.11.484.215.836.208.748-.013 1.218-.687 1.676-1.375a6.112 6.112 0 00.744-1.566l.004-.013-.018-.009c-.165-.077-1.427-.67-1.44-2.258-.011-1.333 1.002-2.008 1.161-2.114a.433.433 0 00.02-.014c-.645-.978-1.65-1.083-1.999-1.11zm5.176 8.386V10.12h3.771c1.947 0 3.307 1.374 3.307 3.383 0 2.01-1.386 3.397-3.358 3.397h-2.16v3.522h-1.56zm1.56-8.954h1.799c1.353 0 2.127.74 2.127 2.042 0 1.302-.774 2.049-2.134 2.049h-1.792v-4.091zm10.668 7.719c-.412.806-1.321 1.315-2.3 1.315-1.451 0-2.463-.886-2.463-2.22 0-1.322.98-2.082 2.791-2.195l1.947-.119V15.4c0-.84-.535-1.295-1.49-1.295-.786 0-1.36.416-1.476 1.05h-1.405c.045-1.334 1.27-2.306 2.927-2.306 1.785 0 2.946.958 2.946 2.445v5.128h-1.444v-1.235h-.033zm-1.882.092c-.831 0-1.36-.41-1.36-1.037 0-.648.51-1.025 1.483-1.084l1.734-.113v.582c0 .965-.8 1.652-1.857 1.652zm8.148 1.547c-.625 1.804-1.34 2.398-2.862 2.398-.116 0-.503-.013-.593-.04V21.95c.096.013.335.026.457.026.69 0 1.077-.297 1.316-1.07l.141-.456-2.643-7.5h1.631l1.837 6.086h.033l1.837-6.087h1.585l-2.74 7.878z",
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 5.5,
    stroke: "#F2F4F7"
  })));
}
export default SvgApplePay;